let jsHistory = {
    initHistorySlider: function(slider){
        $('.history__slider').slick({
            adaptiveHeight: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: false,
            arrows: true,
            dots: false,
            speed: 600,
            infinite: false,
            prevArrow : '<div class="slick-prev"><span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg></span></div>',
            nextArrow : '<div class="slick-next"><span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg></span></div>',
            responsive: [
                {
                    breakpoint: 1281,
                    settings: {
                        slidesToScroll: 2,
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        adaptiveHeight: true,
                        slidesToScroll: 1,
                        slidesToShow: 1
                    }
                }
            ]
        });
    },
    playVideoHistory: function() {
        var videoWrap = $('[data-wrap-video-history-about]'),
            video = videoWrap.find('[data-type-video]');

        if(video.length) {
            var typeVideo = video.data('type-video');

            if(typeVideo == 'bx-player'){
                var id = video.find('[id]').first().attr('id');
                jwplayer(id).play();
            }
            if(typeVideo == 'youtube'){
                jsHistory.playYoutube(video);
            }
        }
    },
    stopVideoHistory: function() {
        var videoWrap = $('[data-wrap-video-history-about]'),
            video = videoWrap.find('[data-type-video]');

        if(video.length) {
            var typeVideo = video.data('type-video');

            if(typeVideo == 'bx-player'){
                var id = video.find('[id]').first().attr('id');
                jwplayer(id).play();
            }
            if(typeVideo == 'youtube'){
                jsHistory.stopYoutube(video);
            }
        }
    },
    playYoutube: function(video) {
        var srcVideo = video.attr('src'),
            srcPlayVideo;

        if (srcVideo.indexOf('autoplay=0')){
            srcPlayVideo = srcVideo.replace('autoplay=0', 'autoplay=1');
            video.attr('src', srcPlayVideo);
        }
    },
    stopYoutube: function(video) {
        var srcVideo = video.attr('src'),
            srcPlayVideo;

        if (srcVideo.indexOf('autoplay=1')){
            srcPlayVideo = srcVideo.replace('autoplay=1', 'autoplay=0');
            video.attr('src', srcPlayVideo);
        }
    },
    initFirstScreenHistory: function() {

        var tl = new TimelineMax({repeat:0},0); 
        tl.
            to([".video-elem__wrap"], 0.5, {
                width: "50%"
            })
            .to(".history__right",0.2,{
                display: "inline-block",
                delay: 0
            })
            .from([".history__factory", ".history__title"],0.3,{
                opacity: 0,
                delay: 0.3
            })           
            .from([".history__descr", ".history__desc"],0.3,{
                opacity: 0,
                delay: 0.2
            })
            .from([".history__btn-play", ".history__more-link"],0.3,{
                opacity: 0,
                delay: 0.2
            });

        // init controller
        var controller = new ScrollMagic.Controller();

        // create a scene
        var scene = new ScrollMagic.Scene({
                triggerElement: '[data-history]',
                offset: 100
            })
            .setTween(tl);

        controller.addScene(scene);
    },
    goToFirstScreen: function() {
        var clear = new TimelineMax({repeat:0},0);

        clear.to([".history__screen_screen1",".history__screen_intro",".history__screen_slider"], 2,
                {
                    transform: "translatex(0%)",
                    delay: 0
                })
            .to(".history__sidebar",0, {
                opacity: 0
            },"-=2")
            .to(".history__sidebar",2, {
                transform: "translatex(0%)"
            },"-=2");

        $('[data-wrap-video-history-about]').removeClass('no-current');
    },
    goToSecondScreen: function() {
        var tl2 = new TimelineMax({repeat:0},0);

        tl2.to([".history__screen_screen1",".history__screen_intro",".history__screen_slider"], 2,{
            transform: "translatex(-100%)",
            delay: 0
        })
        .to(".history__sidebar",0,{
            opacity: 1
        })
        .from(".history__screen_intro .history__sidebar",0.3,{
            width: 0,
            overflow: "hidden",
            padding: 0,
            delay: 0.3
        },"-=0.5")
        .from(".history__film-link",0.3,{
            opacity: 0,
            delay: 0.3
        }).from(".history__intro-title",0.2,{
            opacity: 0
        }).staggerFrom(".history__intro-text", 0.2,{
            opacity:0
        }).from(".history__intro-link",0.4,{
            opacity: 0
        });

        $('[data-wrap-video-history-about]').addClass('no-current');
    },
    goToThirdScreen: function() {
        var tl3 = new TimelineMax({repeat:0},0);

        tl3.to([".history__screen_screen1",".history__screen_intro",".history__screen_slider"], 2, {
            transform: "translatex(-200%)",
            delay:0
        }).to(".history__sidebar",2, {
            transform: "translatex(100%)"
        },"-=2")
    }
}

// // history
$(document).ready(function ($) {

    let history = $('[data-history]');

    if(history.length) {
        var historySliderWrap = $(".history__slider-wrap");
        
        jsHistory.initHistorySlider();

        jsHistory.initFirstScreenHistory();

        $(window).resize(function(){
            jsHistory.goToFirstScreen();
        });

        //onclicks
        //to second slide
        $("[data-btn-watch-film-history-about]").on("click",function(e){
            e.preventDefault();

            jsHistory.goToFirstScreen();

            jsHistory.playVideoHistory();
            $('[data-wrap-video-history-about]').addClass('play');
            $('.history__right').addClass('play-video');
        });

        //to second slide
        $("[data-btn-goto-second-screen-history]").on("click",function(e){
            e.preventDefault();

            jsHistory.stopVideoHistory();
            jsHistory.goToSecondScreen();
        });

        //to third slide
        $("[data-btn-goto-third-screen-history]").on("click", function(e){
            e.preventDefault();
            jsHistory.goToThirdScreen();
        });

        $('[data-btn-play-video-history-about]').on('click', function(e){
            e.preventDefault();

            jsHistory.playVideoHistory();
            $('[data-wrap-video-history-about]').addClass('play');
            $('.history__right').addClass('play-video');
        });
    } //isset

});


// WEBPACK FOOTER //
// ./components/history.js